import styled, { css } from 'styled-components';
import media from '../../../constants/media';
import { Column, Columns } from '../grid';

export const tableStyles = css`
	border-collapse: collapse;
	width: 98%;
`;

export const Table = styled.table`
	${tableStyles};
	${({ minWidth }) =>
		minWidth &&
		css`
			min-width: ${minWidth};
		`}
`;

export const tableRowStyles = css`
	align-items: stretch;
	transition: background-color 50ms;

	&:nth-child(odd) {
		background-color: ${({ theme }) => theme.colors.grayLighter2};
	}

	&:not(:last-child) {
		border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	}

	&:hover {
		background-color: rgba(0, 87, 184, 0.08);
	}
`;

export const TableRow = styled(Columns)`
	${tableRowStyles};
`;

export const tableHeaderStyles = css`
	text-align: left;
	color: ${({ theme }) => theme.colors.primary};
	background-color: #fff;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	margin: 0;
	padding-top: 1.2rem;
	padding-bottom: 1.2rem;

	&:first-child {
		padding-left: 3rem;
	}
`;

export const TableHeader = styled(Column)`
	${tableHeaderStyles};
`;

export const tableDataStyles = css`
	position: relative;
	margin: 0;
	margin-bottom: 0rem;
	padding-top: 1.2rem;
	padding-bottom: 1.2rem;
	border: none;
	&:not(:last-child) {
		border-right: 1px solid ${({ theme }) => theme.colors.borderColor};
	}

	&:first-child {
		padding-left: 3rem;
	}

	${media.desktopSmall`
		margin: 0;
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	`};

	p {
		margin: auto 0;
	}
`;

export const TableData = styled(Column)`
	${tableDataStyles};
`;

export const TableMobileLabel = styled.div`
	position: absolute;
	top: 50%;
	right: 1.5rem;
	transform: translateY(-50%);
	font-size: 1.2rem;
	color: ${({ theme }) => theme.colors.grayLight};
	max-width: 6rem;

	${media.desktopSmall`
		display: none;
	`};
`;
